import produce from 'immer';
import _ from 'lodash';

import { lsNames } from 'client/constants/common';

export const getStoryLastCardId = (storyId: string): string => {
	const scHistory = JSON.parse(window.localStorage.getItem(lsNames.history) || '{}');
	const lastCardId = _.get(scHistory, `${storyId}.cardId`);

	return lastCardId;
};

export const updateStoryLastCardId = (storyId: string, cardId: string): void => {
	if (window.localStorage) {
		const scHistory = JSON.parse(window.localStorage.getItem(lsNames.history) || '{}');
		const scHistoryUpdated = produce(scHistory, draft => {
			_.set(draft, `${storyId}.cardId`, cardId);
		});
		window.localStorage.setItem(lsNames.history, JSON.stringify(scHistoryUpdated));
	}
};
